import Collection from '../collection';
import Status from '../model/status';





export default Collection.extend( {
	endpoint: 'statuses/list/all?apiVersion=2.0',
	responseAt: 'items',
    model: Status
} );


// WEBPACK FOOTER //
// ./src/js/collection/statuses.js